module.exports = __webpack_public_path__ + "img/bg_avatar_male_37.f9531e60.png";